import { toast } from "react-toastify";
import { createSlice } from "@reduxjs/toolkit";
import { apiUrl } from "../../Constant";
import { apiCall } from "../../Services/CommonService";

const tokenFromStorage = localStorage.getItem("token");
const userIdFromStorage = localStorage.getItem("userId");

const initialState = {
  token: tokenFromStorage || "",
  userId: userIdFromStorage || null,
  profileData: null,
  userName: null,
  cartCount: 0,
  likeCount: 0,
  isLoginLoading: false,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    logout: (state) => {
      localStorage.removeItem("token");
      localStorage.removeItem("userId");
      localStorage.removeItem("tdc_retailer_settings");
      localStorage.removeItem("tdc_product_range_menu");
      localStorage.removeItem("tdc_branded_jewellery_menu");
      localStorage.removeItem("tdc_watches_menu");

      state.token = "";
      state.userId = null;
      state.profileData = null;
      state.userName = null;
      state.cartCount = 0;
      state.likeCount = 0;
    },
    setUserID: (state, action) => {
      state.userId = action.payload;
    },
    getProfileData: (state, action) => {
      state.profileData = action.payload;
    },
    setUserName: (state, action) => {
      state.userName = action.payload;
    },
    setIsLoginLoading: (state, action) => {
      state.isLoginLoading = action.payload;
    },
    setToken: (state, action) => {
      state.token = action.payload;
    },
    setCartCount: (state, action) => {
      state.cartCount = action.payload;
    },
    setLikeCount: (state, action) => {
      state.likeCount = action.payload;
    },
  },
});

export const {
  setCartCount,
  setUserID,
  getProfileData,
  setUserName,
  logout,
  setToken,
  setLikeCount,
  setIsLoginLoading,
  setSideBarIndex,
} = userSlice.actions;

export default userSlice.reducer;

export const getProfileApi = (token) => (dispatch) => {
  // Signed out: there is nobody to fetch. This used to fire on every page load
  // regardless, so a visitor who had not logged in collected a 401 on every
  // single page — red in the console of a site that is otherwise clean.
  // Clearing the profile here also keeps logout honest: the header greeting
  // empties out instead of holding on to the last customer's name.
  if (!token) {
    dispatch(getProfileData(null));
    dispatch(setIsLoginLoading(false));
    return;
  }
  dispatch(setIsLoginLoading(true));
  try {
    const onSuccess = (response) => {
      dispatch(getProfileData(response?.user));
      dispatch(setIsLoginLoading(false));
    };
    const onFailure = (error) => {
      dispatch(setIsLoginLoading(false));
    };
    apiCall("GET", `${apiUrl.GET_PROFILE}`, "", onSuccess, onFailure, token);
  } catch (error) {
    dispatch(setIsLoginLoading(false));
  }
};

export const updateProfileApi =
  (value, token, onSuccessCallback) => (dispatch) => {
    dispatch(setIsLoginLoading(true));
    try {
      const onSuccess = (res) => {
        console.log("res ==> ", res);
        toast.success(res?.message);
        onSuccessCallback(res);
        dispatch(getProfileApi(token));
        dispatch(setIsLoginLoading(false));
      };
      const onFailure = (error) => {
        dispatch(setIsLoginLoading(false));
      };

      apiCall(
        "PATCH",
        `${apiUrl.UPDATE_PROFILE}`,
        value,
        onSuccess,
        onFailure,
        token,
      );
    } catch (error) {
      dispatch(setIsLoginLoading(false));
    }
  };
